import axios from 'axios';
export const getDiscountList = ({ pageNo = 1, cb, token }) => {
	return dispatch => {
		return axios
			.get(
				// `/marketplace/discount/service/listAllDiscounts.service?pageSize=50&state=&currentPage=${pageNo}&supplierId=`
				`/vendorapis/discount/discount/listAllDiscountRule?currentPage=${pageNo}&pageSize=50&token=${token}`
			)
			.then(data => {
				cb && cb(data);
				const pageData = data.data.page;
				dispatch({
					type: 'SET_DISCOUNT_LIST',
					payload: {
						pageNo,
						totalCount: pageData.totalCount,
						results: pageData.results
					}
				});
			});
	};
};

export const getCSRFToken = ({ token, sid }) => {
	const url = `/marketplace/static/php/web/b2bWebsite.php?action=getCSRFToken&token=${token}&sid=${sid}`;
	return dispatch => {
		return axios.get(url).then(res => {
			dispatch({
				type: 'SET_CSRF_TOKEN',
				payload: {
					csrfToken: res.data.CSRFtoken,
					expiryDate: res.data.expiryDate
				}
			});
		});
	};
};

export const getMobileList = ({ pageNo = 1, token }, options) => {
	axios
		.get(
			// `/marketplace/discount/service/listAllDiscounts.service?pageSize=50&state=&currentPage=${pageNo}&supplierId=`
			`/vendorapis/discount/discount/listAllDiscountRule?currentPage=${pageNo}&pageSize=50&token=${token}`
		)
		.then(data => {
			const pageData = data.data.page;
			if (pageData) {
				options.cb && options.cb(pageData, data);
			}
		});
};

export const getPopoverData = (params, options) => {
	let url = '';
	let item = params.item;
	if (params.type === 'CUSTOMER_GROUP') {
		url =
			'/marketplace/customer/ajax/getAllGroupsForDiscount.service?discountId=' +
			item.id;
	} else if (params.type === 'PRODUCTS') {
		// url = "/marketplace/discount/service/getProdInfoByIds.service?appliedOn=PRODUCTS&ids=";
		url = '/vendorapis/discount/discount/getProdInfoByIds?ids=';
		url += item.appliedOnIds + '&token=' + params.token;
	} else if (params.type === 'GROUPS' || params.type == 'CATEGORIES') {
		url =
			'/vendorapis/discount/discount/getAutomatedCategoriesById?categoryIds=';
		url += params.type == 'GROUPS' ? item.appliedOnIds : item;
	}
	url += '&token=' + params.token;
	axios.get(url).then(({ data }) => {
		if (data) {
			let popoverList = [];
			if (params.type === 'CUSTOMER_GROUP') {
				popoverList = data.results.data;
			} else {
				if (item.appliedOn === 'PRODUCTS') {
					if (!data.prodIdsInfo || !data.prodIdsInfo.length) {
						popoverList = [
							{
								productName:
									'Selected Product(s) have been deleted.'
							}
						];
					} else {
						popoverList = data.prodIdsInfo;
					}
				} else if (
					item.appliedOn === 'GROUPS' ||
					params.type === 'CATEGORIES'
				) {
					popoverList = data.data;
				}
			}
			if (popoverList.length > 8) {
				//popoverList.splice(0, 8);
				popoverList = popoverList.slice(0, 8);
				popoverList.push({
					productName: 'View More',
					productGroupName: 'View More',
					customerGroupName: 'View More'
				});
			}
			options.cb && options.cb(popoverList);
		}
	});
};

export const openSlider = ({ type, data, extraOptions }) => ({
	type: 'OPEN_SLIDER',
	payload: {
		type,
		open: true,
		data,
		extraOptions
	}
});

export const closeSlider = ({ type, data, extraOptions }) => ({
	type: 'CLOSE_SLIDER',
	payload: {
		type,
		open: false,
		data,
		extraOptions
	}
});

// export const isManualCategorization = (supplierId,options)=>{
//   axios.get(`/marketplace/vendorStore/storeDetail.service?supplierId=${supplierId}`)
//   .then(({ data }) => {
//       if(data){
//           options.cb && options.cb(data);
//       }
//   })
// }
